export default __webpack_public_path__ + "static/media/historic-site.2642309d.svg";